import { BrowserRouter, Route, Routes } from "react-router-dom";
import { Gate } from "@/components/layout/Gate";
import { Shell } from "@/components/layout/Shell";
import { ApiProvider } from "@/lib/api";
import { AuthProvider } from "@/lib/auth";
import { QueryProvider } from "@/lib/query/QueryProvider";
import { AssistantScreen } from "@/screens/AssistantScreen";
import { ConfirmScreen } from "@/screens/auth/ConfirmScreen";
import { SignInScreen } from "@/screens/auth/SignInScreen";
import { SignUpScreen } from "@/screens/auth/SignUpScreen";
import {
  ConversationScreen,
  ConversationsScreen,
} from "@/screens/ConversationsScreen";
import { InstallScreen } from "@/screens/InstallScreen";
import { IntegrationsScreen } from "@/screens/IntegrationsScreen";
import { KnowledgeScreen } from "@/screens/KnowledgeScreen";
import { LeadsScreen } from "@/screens/LeadsScreen";
import { OverviewScreen } from "@/screens/OverviewScreen";
import { DocumentsStep } from "@/screens/onboarding/DocumentsStep";
import { OnboardingLayout } from "@/screens/onboarding/OnboardingLayout";
import { PagesStep } from "@/screens/onboarding/PagesStep";
import { StyleStep } from "@/screens/onboarding/StyleStep";
import { WebsiteStep } from "@/screens/onboarding/WebsiteStep";

export function App() {
  return (
    <AuthProvider>
      <ApiProvider>
        <QueryProvider>
          <BrowserRouter>
            <Routes>
              <Route path="/sign-up" element={<SignUpScreen />} />
              <Route path="/sign-in" element={<SignInScreen />} />
              <Route path="/confirm" element={<ConfirmScreen />} />
              <Route
                path="/onboarding"
                element={
                  <Gate onboarding>
                    <OnboardingLayout />
                  </Gate>
                }
              >
                <Route path="website" element={<WebsiteStep />} />
                <Route path="documents" element={<DocumentsStep />} />
                <Route path="style" element={<StyleStep />} />
                <Route path="pages" element={<PagesStep />} />
              </Route>
              <Route
                element={
                  <Gate>
                    <Shell />
                  </Gate>
                }
              >
                <Route index element={<OverviewScreen />} />
                <Route path="knowledge" element={<KnowledgeScreen />} />
                <Route path="assistant" element={<AssistantScreen />} />
                <Route path="integrations" element={<IntegrationsScreen />} />
                <Route path="install" element={<InstallScreen />} />
                <Route path="leads" element={<LeadsScreen />} />
                <Route path="conversations" element={<ConversationsScreen />} />
                <Route
                  path="conversations/:conversationId"
                  element={<ConversationScreen />}
                />
                <Route
                  path="*"
                  element={<p className="text-muted">Nothing here.</p>}
                />
              </Route>
            </Routes>
          </BrowserRouter>
        </QueryProvider>
      </ApiProvider>
    </AuthProvider>
  );
}
